import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedLayout from './auth/ProtectedLayout';
import Login from './auth/Login';
import SignupAccess from './auth/SignupAccess';
import Signup from './auth/Signup';
import AdminSignupRequests from './access/AdminSignupRequests';
import SignupProtectedRoute from './auth/SignupProtectedRoute';
import AdminDashboard from './dashboard/AdminDashboard';
import SuperAdminDashboard from './platform/SuperAdminDashboard';
import SalesAnalytics from './sales/SalesAnalytics';
import MenuManagement from './menu/MenuManagement';
import OrderManagement from './orders/OrderManagement';
import BillManagement from './bills/BillManagement';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup-access" element={<SignupAccess />} />
        <Route
          path="/signup"
          element={
            <SignupProtectedRoute>
              <Signup />
            </SignupProtectedRoute>
          }
        />
        <Route element={<ProtectedLayout />}>
          <Route path="/dashboard" element={<AdminDashboard />} />
          <Route path="/signup-requests" element={<AdminSignupRequests />} />
          <Route path="/super-admin" element={<SuperAdminDashboard />} />
          <Route path="/menu" element={<MenuManagement />} />
          <Route path="/orders" element={<OrderManagement />} />
          <Route path="/bills" element={<BillManagement />} />
          <Route path="/sales" element={<SalesAnalytics />} />
        </Route>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;


